import { Event } from '../../_base/eventBus/EventBus';

export class ClaimCreated implements Event {}